var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 20,
    viewBox: "0 0 29 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8457 10.3161L28.5273 16.2675V4.11328L19.8457 10.3161Z",
    fill: "#DECDAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.746094 4.11328V16.2675L9.42771 10.3161L0.746094 4.11328Z",
    fill: "#DECDAD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8367 0.640625H2.43667C1.56698 0.640625 0.876808 1.27574 0.746094 2.09354L14.6367 11.0586L28.5273 2.09354C28.3966 1.27574 27.7064 0.640625 26.8367 0.640625Z",
    fill: "#DECDAD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5828 11.0604L15.1161 12.7408C14.9696 12.84 14.804 12.8887 14.6367 12.8887C14.4693 12.8887 14.3037 12.84 14.1573 12.7408L11.6905 11.0586L0.746094 18.2184C0.880328 19.0749 1.56719 19.7402 2.4336 19.7402H26.8398C27.7062 19.7402 28.393 19.0749 28.5273 18.2184L17.5828 11.0604Z",
    fill: "#DECDAD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.b88ac87926c327b2b31221cfaac6df95.svg";
export { ForwardRef as ReactComponent };